module.exports = __webpack_public_path__ + "static/img/RUPS1612RP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RUPS1612RP_1.png
// module id = L4Vl
// module chunks = 0